
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypePassengerFilled as ObiVesselTypePassengerFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-passenger-filled.js';
 
 
 

 
 export const ObiVesselTypePassengerFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-type-passenger-filled',
   elementClass: ObiVesselTypePassengerFilledElement,
   events: {
     
   }
  });
 
 